export enum EstateFormTemplateKey {
  FORM_523201 = 523201, // Ontario - 74A - application for a certificate of appointment of estate trustee
  FORM_833724 = 833724, // Ontario - 74B - affidavit of service of application for a certificate of appointment of estate trustee
  FORM_992177 = 992177, // Ontario - 74C - certificate of appointment of estate trustee
  FORM_615340 = 615340, // Ontario - 74G - renunciation
  FORM_891637 = 891637, // Ontario - 74H - consent
  FORM_381570 = 381570, // Ontario - 74I - order in an estates proceeding
  FORM_141210 = 141210, // Ontario - Affidavit to Dispense with Bond
  FORM_647126 = 647126, // Ontario - Estate Information Return (EIR)
  FORM_403185 = 403185, // Ontario - EIR Schedule
  FORM_739268 = 739268, // British-Columbia - P1 - certificate of appointment of estate trustee
  FORM_813676 = 813676, // British-Columbia - P10
  FORM_212259 = 212259, // British-Columbia - P2
  FORM_643151 = 643151, // British-Columbia - P3
  FORM_172511 = 172511, // British-Columbia - P5
  FORM_349542 = 349542, // British-Columbia - P8
  FORM_384174 = 384174, // British-Columbia - P9
  FORM_725811 = 725811, // Saskatchewan - 7 - certificate that no persons under the age of eighteen years interested
  FORM_255255 = 255255, // Saskatchewan - 11A
  FORM_216147 = 216147, // Saskatchewan - 11B
  FORM_915248 = 915248, // Saskatchewan - 11C
  FORM_132453 = 132453, // Saskatchewan - 12
  FORM_447137 = 447137, // Saskatchewan - 13A
  FORM_994938 = 994938, // Saskatchewan - 13B
  FORM_349458 = 349458, // Saskatchewan - 14
  FORM_715717 = 715717, // Saskatchewan - 19A
  FORM_408559 = 408559, // Saskatchewan - 19B
  FORM_886809 = 886809, // Manitoba - affidavit execution nomination
  FORM_762991 = 762991, // Manitoba - 74a
  FORM_787771 = 787771, // Manitoba - 74b
  FORM_931048 = 931048, // Manitoba - 74c
  FORM_783104 = 783104, // Manitoba - 74d
  FORM_917668 = 917668, // Manitoba - 74e
  FORM_664153 = 664153, // Manitoba - 74f
  FORM_818753 = 818753, // Manitoba - 74j
  FORM_338211 = 338211, // Manitoba - 74k
  FORM_229911 = 229911, // Manitoba - 74l
  FORM_295422 = 295422, // Manitoba - 74m
  FORM_393987 = 393987, // Manitoba - 74n
  FORM_214942 = 214942, // Manitoba - 74o
  FORM_826249 = 826249, // Manitoba - 74r
  FORM_868624 = 868624, // Manitoba - 74t1
  FORM_902309 = 902309, // California - DE-161 Attachment 1 v2 (google docs)
  FORM_337290 = 337290, // California - DE-161 Attachment 2 v2
  FORM_930175 = 930175, // CRA Request to update records
  FORM_610609 = 610609, // ISP 1201 - CPP notification of death;
  FORM_110972 = 110972, // ISP 1200 - CPP death benefit application;
  FORM_412604 = 412604, // ISP 1300 - CPP survivor's pension and children's benefits application;
  FORM_337039 = 337039, // Equifax notice
  FORM_370796 = 370796, // Notice to TransUnion;
  FORM_234534 = 234534, // Guide to handling owned real estate
  FORM_349834 = 349834, // Canada Post declaration
  FORM_980723 = 980723, // USPS Declaration
  FORM_897234 = 897234, // Notification to Insurance Provider
  FORM_783452 = 783452, // Notification to landlord
  FORM_738249 = 738249, // Guide to handling vehicles
  FORM_512387 = 512387, // Notification to vehicle insurance provider
  FORM_926541 = 926541, // Guide to handling valuables
  FORM_803219 = 803219, // Guide to handling firearms
  FORM_475832 = 475832, // Firearm license return
  FORM_763219 = 763219, // Cancel Google Accounts
  FORM_948103 = 948103, // Cancel Amazon Accounts
  FORM_540192 = 540192, // Cancel Microsoft Accounts
  FORM_379878 = 379878, // Notice to Experian
  FORM_238472 = 238472, // Lump sum death payment
  FORM_341234 = 341234, // Obtain certified copies of death certificate
  FORM_204124 = 204124, // Locating and claiming life insurance benefits
  FORM_298734 = 298734, // QC - Declaration of heredity
  FORM_648523 = 648523, // QC - Information about representative
  FORM_234234 = 234234, // QC - Designation of liquidator (RDPRM)
  FORM_234235 = 234235, // QC - Designation of liquidator Annex (RDPRM)
  FORM_765432 = 765432, // Quebec - Designation of liquidator by heirs,
  FORM_876543 = 876543, // Quebec - Closure of the Inventory to the RDPRM
  FORM_329481 = 329481, // Notice to creditors
  FORM_548312 = 548312, // Fiduciary Relationship Notice
  FORM_120395 = 120395, // Letter to Victims Compensation Board
  FORM_478088 = 478088, // Notice to Department of Health Care Services
  FORM_967195 = 967195 // Notice to Franchise Tax Board
}
